<template>
    <div class="item-container">
       <div class="item-content" v-for="type in types" :key="type.label">
        <div class="item-title">
            <span>{{ type.label }}</span>    
            <span @click="$router.push(type.path)">更多</span>    
        </div>
        <div> 
            <div v-for="d in type.data" class="item-data">
                <div>{{d.time ? `【${d.time}】`: '' }} {{ d.title }}</div>
                <div>{{ type.label}}</div>
            </div>    
        </div>
       </div>
        
    </div>
</template>
<script>
    import {rent} from '../data/rent.js'
    import {transfer} from '../data/transfer'
    import {vech} from '../data/vichcle'
    import {orders} from '../data/order'
    import {wantjob} from '../data/wantjob'
    import {pet} from '../data/pet'
    import {service} from '../data/service'
    export default {
        name: 'Index',
        data() {
            return {
                types: [{
                label: '房屋租售',
                data: rent.rent.slice(0, 5),
                path: '/rent'
                }, {
                    label: '二手转让',
                    data: transfer.data.slice(0, 5),
                    path: '/transfer'
                }, {
                    label: '车辆买卖',
                    data: vech.data.slice(0, 5),
                    path: '/vich'
                }, {
                    label: '招聘信息',
                    data: orders.data.slice(0, 5),
                    path: '/order'
                }, {
                    label: '求职简历',
                    data: wantjob.data.slice(0, 5),
                    path: '/wantjob'
                }, {
                    label: '宠物',
                    data: pet.data.slice(0, 5),
                    path: '/pet'
                }, {
                    label: '生活服务',
                    data: service.data.slice(0, 5),
                    path: '/service'
                }]
            }
        }
       
    }
</script>

<style scoped>
    .item-container {
        padding: 20px 10vw;
        background: #ececec;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .item-content {
       width: calc(25% - 15px); 
       padding: 10px 10px 10px 15px;
       margin-bottom: 15px;
       margin-right: 15px;
       background: white;
       border-radius: 10px;
       box-sizing: border-box;
    }
    .item-title {
        padding-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .item-title > span:first-child {
        color: #409EFF;
    }

    .item-title > span:nth-child(2) {
        font-size: 13px;
        cursor: pointer;
    }

    .item-data {
        font-size: 14px;
        padding: 5px 0;
        display: flex;
        align-content: center;
    }

    .item-data > div:first-child {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .item-data > div:nth-child(2) {
        white-space: nowrap;
        color: gray;
        font-size: 13px;
    }
   
   
</style>